import React, { ComponentPropsWithRef } from 'react';

import { cn } from '@/utilities/cn';

type PropType = ComponentPropsWithRef<'button'>

export const DotButton: React.FC<PropType> = (props) => {
    const { className, ...restProps } = props;

    return (
        <button
            {...restProps}
            type="button"
            className={cn(
                className,
                'rounded-full w-2 h-2 cursor-pointer border-1 border-solid border-secondary',
                'lg:w-3.5 lg:h-3.5'
            )}
        />
    );
};
